import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=23c3a728&"
import script from "./SocialMedia.vue?vue&type=script&lang=ts&"
export * from "./SocialMedia.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=23c3a728&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports